$(document).ready(function () {

    $('iframe').each(function () {
        const parent = $(this).parent();

        const attributeAspectRatio = 1.2;
        const currentWidth = (parseInt($(this).outerWidth()));
        const parentWidth = (parseInt(parent.outerWidth()));

        if (currentWidth < parentWidth) {
            const newHeight = Math.floor(currentWidth * attributeAspectRatio);

            $(this).css('height', newHeight + 'px');
        }

    });
});